/* src/app/components/modify-contact-data/modify-contact-data.component.scss */
.container {
  gap: 30px;
}
.header ion-button {
  min-height: 0;
  margin: 0;
  --border-radius: 0;
  color: black;
}
.header ion-button::part(native) {
  padding: 0;
}
.header ion-button ion-icon {
  width: 20px;
  height: 20px;
}
.title {
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  gap: 15px;
}
.title ion-icon {
  width: 35px;
  height: 35px;
}
.message {
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #949494;
}
form {
  gap: 15px;
}
form label:not(label[for=replace-contact-data]) {
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
form label:not(label[for=replace-contact-data]) span {
  color: #eb445a;
}
form input {
  padding: 16px 10px;
  border-radius: 10px;
  border: 1px solid #949494;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
form input::placeholder {
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #949494;
}
form input:focus {
  border: 1px solid black;
  outline: 1px solid black;
}
form input:active {
  border: 1px solid black;
  outline: 1px solid black;
}
ion-checkbox {
  --border-radius: 5px;
  --border-width: 1px;
  --border-color: #949494;
  --size: 20px;
}
.replace {
  color: black;
}
.replace > span {
  color: #949494;
}
.error {
  border: 1px solid #eb445a !important;
}
.error:focus {
  border: 2px solid #eb445a !important;
  outline: none !important;
}
.error:active {
  border: 2px solid #eb445a !important;
  outline: none !important;
}
.bottom-buttons ion-button {
  min-height: 0;
  margin: 0;
  --border-radius: 10px;
  font-family: "Barlow Semi Condensed";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.bottom-buttons ion-button::part(native) {
  padding: 14px 18px;
}
.bottom-buttons ion-button:first-of-type {
  --background: #f6f6f6;
  --background-hover: #f3f3f3;
  --background-activated: #e9e9e9;
  color: black;
}
.bottom-buttons ion-button:last-of-type {
  --background: #43c0f6;
  --background-activated: #43bdf1;
}
.gap-five {
  gap: 5px;
}
/*# sourceMappingURL=modify-contact-data.component-FUQ5SPRL.css.map */
